import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/reports/mutationTypes';

export default {
  [types.SET_HIGHLIGHT_REPORTS_LOADING]: createSetPropMutation('highlightReportsLoading', false),
  [types.SET_HIGHLIGHT_REPORTS]: createSetPropMutation('highlightReports', []),
  [types.CLEAR_HIGHLIGHT_REPORTS]: createClearPropMutation('highlightReports', []),
  [types.SET_HIGHLIGHT_REPORTS_STATS]: createSetPropMutation('highlightReportsStats', {}),
  [types.CLEAR_HIGHLIGHT_REPORTS_STATS]: createClearPropMutation('highlightReportsStats', {}),
  [types.CLEAR_HIGHLIGHT_REPORTS_LIST_OPTIONS]: createClearPropMutation('highlightReportsListOptions'),
  [types.SET_HIGHLIGHT_REPORTS_LIST_OPTIONS](state, options = {}) {
    state.highlightReportsListOptions = {
      ...(state.highlightReportsListOptions || {}),
      ...options,
    };
  },
};
